/**
 * client/src/components/layout/recovery-push-listener.tsx
 *
 * Mounts the recovery-approval push listener once, inside the authenticated
 * app shell, so a notice reaches a guardian on whatever page they happen to
 * be on (PR 1, Task 3, refs #2257) — not only if they are already looking
 * at Invitations.
 *
 * Mirrors `handshake-push-listener.tsx` exactly (Reuse-First Check,
 * DEVELOPMENT/quality.md Code Review Criteria #8): on arrival, invalidate
 * the pending-duties query so the Invitations page's "Guardian approvals"
 * section updates without a refresh, and raise a neutral toast with no
 * click-through link (same DEVIATION as the handshake listener: the shared
 * `toast()` primitive gained an optional link slot in #3169, but no caller
 * here uses it), so the reachable link stays the Invitations page's own
 * read.
 *
 * Renders nothing. It is a listener, deliberately not a UI component.
 */

import { useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/ui/toast";
import { RECOVERY_DUTIES_QUERY_KEY } from "@/lib/recovery-duties-api";
import { useRecoveryPush } from "@/lib/use-recovery-push";

export function RecoveryPushListener(): null {
  const queryClient = useQueryClient();
  useRecoveryPush(() => {
    void queryClient.invalidateQueries({ queryKey: RECOVERY_DUTIES_QUERY_KEY });
    toast("A guardian recovery request needs your approval.");
  });
  return null;
}
